import React from 'react'
import styles from './startPage.module.scss'
import '../App/transition.css'

const StartPage = ({openQuiz, closeQuiz, children}) => (
   <div className={styles.startPage}>
      <div className={styles.startPage__btnBlock}>
         <a href='/' className={styles.startPage__closeBtn} onClick={closeQuiz}>
            <span className={styles.startPage__firstSpan}></span>
            <span className={styles.startPage__secondSpan}></span>
         </a>
      </div>
      {children
         ?
            children
         :
         <div className={styles.startPage__block}>
            <h1 className={styles.startPage__title}>Where to find a woman of your dreams?</h1>
            <p className={styles.startPage__subtitle}>Complete the 2-minute test to find out where to find your perfect
               match</p>
            <button className={styles.startPage__btn} onClick={openQuiz}>start test</button>
         </div>
      }
   </div>

)

export default StartPage